import { FlexibleData } from '@lib/server';
import { clsx } from 'clsx';

import { PageRender } from '../util/page-render';
import { BlockBase, columnsClassName, getMarginClassNames } from './utils';

export interface AccentSectionProps extends BlockBase {
  variant: 'default' | 'primary' | 'secondary' | 'accent' | 'card';
  content: FlexibleData;
}

export function AccentSection({ id, variant, content, params, margin }: AccentSectionProps) {
  return (
    <div
      id={id}
      className={clsx(
        getMarginClassNames(margin),
        columnsClassName,
        'flex w-full flex-col items-center py-8 group-[.flex-col]:rounded-lg group-[.flex-col]:py-4 sm:py-20 sm:group-[.flex-col]:py-8',
        {
          'bg-accent text-accent-foreground': variant === 'accent',
          'bg-primary text-primary-foreground': variant === 'primary',
          'bg-secondary text-secondary-foreground': variant === 'secondary',
          'bg-card text-card-foreground': variant === 'card',
        },
      )}
    >
      <PageRender data={content} params={params} />
    </div>
  );
}
